<template>
  <donut-table :headers="tableHeaders" :data="tableData" :disabled="!tableEnabled">
    <template #badge="{ entry }"><div v-emoji="`${entry.badge.emoji} ${entry.badge.name}`" class="t" /></template>
    <template #points="{ entry, rowIdx }">
      <donut-input-async-number
        :ref="(el) => pointsInputRefs[`points-input${entry.badge.id}`] = el"
        :model-value="entry.points"
        :paywall="paywall('customize Badge points', 'num-points')"
        @submit="(val, onComplete) => onPointsSubmit(entry, val, onComplete)"
        @advance="focusNextPointsInput(rowIdx + 1)"
      />
    </template>
    <template #description="{ entry }"><div class="t">{{ entry.badge.description }}</div></template>
    <template #enable="{ entry }">
      <donut-input-toggle
        v-if="tableEnabled"
        size="small"
        :model-value="entry.active"
        :paywall="paywall('disable Badge points', 'badge-enabled')"
        update-action="pointsConfig/toggleBadgeConfig"
        :update-args="{ badgeConfig: entry }"
        :load-on-toggle="true"
      />
      <donut-input-toggle v-else :model-value="false" size="small" /> <!-- Decoy "off" toggles for when the table is turned off-->
    </template>
  </donut-table>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const props = defineProps({
    badges: { type: Array, required: true },
  });
  const { state, dispatch } = useStore();

  const tableHeaders = [
    { key: 'badge', label: 'Badge', weight: 2 },
    { key: 'points', label: state.pointsConfig.config.points_name_plural, weight: 1 },
    { key: 'description', label: 'Actions', weight: 3 },
    { key: 'enable', label: 'Enable', weight: 1 },
  ];
  const tableData = state.pointsConfig.config.badge_configs;
  const tableEnabled = computed(() => state.pointsConfig.config.award_points_for_badges);

  const paywall = (featureTitleText, sourceSuffix) => ({
      data: state.pointsConfig.config.upgrade_data,
      feature: 'award_points_for_badges',
      featureTitleText,
      source: `automatic-points-badges-${sourceSuffix}`,
      programKey: 'shoutouts',
    });

  // Points Inputs
  const pointsInputRefs = ref({});
  const onPointsSubmit = (badgeConfig, points, onComplete) => {
    const oldPoints = badgeConfig.points;
    if (points < 1 || parseInt(points) !== points) {
      onComplete({ value: oldPoints, icon: 'error' });
      dispatch('setErrorToast', 'Value must be a whole number greater than 0.');
    } else {
      dispatch('pointsConfig/updateBadgeConfig', { badgeConfig, params: { points } })
        .then(() => { onComplete({ icon: 'success' }); })
        .catch(() => { onComplete({ value: oldPoints, icon: 'error' }); });
    }
  };
  const focusNextPointsInput = (idx) => {
    const badgeConfig = state.pointsConfig.config.badge_configs[idx];
    const inputEl = pointsInputRefs.value[`points-input${badgeConfig.badge.id}`];
    if (inputEl) inputEl.open();
  };
</script>
